import { sendGTMEvent } from '@next/third-parties/google';

/**
 * @description Wrapper function for sending Google Tag Manager events
 * @param eventName - The name of the event to send
 * @param type - The type of event (e.g., 'pageview', 'click', etc.)
 * @param payload - Optional additional data to include with the event
 */
export default function sendGoogleTagEvent(
  eventName: string,
  type: string,
  payload?: { [key: string]: unknown },
) {
  const eventParams: { [key: string]: unknown } = {
    type: `${type}`,
    platform: 'react',
    ...payload,
  };
  sendGTMEvent({
    event: eventName,
    ...eventParams,
  });
}
